<template>
	<div class="bg-white px-3 goods_create" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 78vh;">
		<router-link :to="{name:'scgl_scrw_scdd'}" style="position: absolute;top: 12px;left: 200px;">
			<el-button size="mini">回到工资表</el-button>
		</router-link>

		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 35%;">
					<el-form-item label="工资编号">
						<el-input :disabled="true" v-model="lists.id"></el-input>
					</el-form-item>
					<el-form-item label="关联员工">
						<el-select v-model="lists.ywy" filterable style="width: 90%;">
						    <el-option v-for="item in ywylist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="供应商">
						<el-select v-model="lists.gys" filterable style="width: 90%;">
						    <el-option v-for="item in gyslist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订单金额">
						<el-input-number v-model="lists.ddje" :precision="2"></el-input-number>
					</el-form-item>
					
					
				</div>
				<div style="width: 33%;">
					<el-form-item label="是否外包"><el-switch v-model="lists.sfwb" active-color="#13ce66" inactive-color="#ff4949"></el-switch></el-form-item>
					<el-form-item label="部门">
						<el-select v-model="lists.bm" filterable style="width: 90%;">
						    <el-option v-for="item in bmlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="仓库仓位">
						<el-select v-model="lists.ckcw" filterable style="width: 90%;">
						    <el-option v-for="item in cklist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商品总额">
						<el-input-number v-model="lists.spze"  :precision="2"></el-input-number>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="备注">
						<el-input v-model="lists.desc" style="width: 95%;"></el-input>
					</el-form-item>
					<el-form-item label="收款账户">
						<el-select v-model="lists.fkzh" filterable style="width: 90%;">
						    <el-option v-for="item in sklist" :key="item.id" :label="item.mc" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					
				</div>
			</div>
		</el-form>
		
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;justify-content: center;">
			<el-button type="primary" @click="submit">提交</el-button>
		</el-footer>

	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import common from '@/common/mixins/common.js';
	export default {
		mixins: [common],
		inject: ['app', 'layout'],

		data() {
			return {
				lists: {},
				ywylist:[],
				gyslist:[],
				cklist:[],
				cplist:[],
				bmlist:[],
				sklist:[],

				valuea: false,
				createModel: false,
				preUrl: 'cpgl',
				multipleSelection:[],
				rkcps:[],
				glth:'',
			}
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			}),


			
		},
		created() {
			this.lists = this.$route.params.data;
			if(this.lists.rkcps != 0){
				this.rkcps = this.lists.rkcps
			}
			if(this.lists.sfkp == 0){
				this.valuea = false
			}else{
				this.valuea = true
			};
			this.axios.get('/admin/managers/list', { token: true }).then(res => {
				this.ywylist = res.data.data;
			});
			this.axios.get('/admin/gyss', { token: true }).then(res => {
				this.gyslist = res.data.data;
			});
			this.axios.get('/admin/cangkus', { token: true }).then(res => {
				this.cklist = res.data.data;
			});
			this.axios.get('/admin/bumens/list', { token: true }).then(res => {
				this.bmlist = res.data.data;
			});
			this.axios.get('/admin/cwzj/1', { token: true }).then(res => {
				this.sklist = res.data.data.list;
			});
		},
		methods: {
			pustyl() {
				this.createModel = true;
			},
			submits(e) {
				this.rkcps = e.map(i=>{
					return {
						sl:0,
						dj:0,
						hj:0,
						dw:i.jldw.name,
						cpid:i.id,
						cpbm:i.cpbm,
						cpmc:i.cpmc,
						ggbm:i.cpgg.ggbm,
						ggmc:i.cpgg.name,
						bzqts:i.bzqts,
						lx:i.cplx,
						pch:i.pch
					}
				})
				// console.log(this.rkcps)
				this.createModel = false;
			},
			getListUrl() {
				
				return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`
			},
			getListResult(e) {
				this.cplist = e.list;
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			navigate(name, e) {
				// 初始化表单
				if(!e){
					var data = {
						cpmc:'',
						desc:'',
						cpbm:'',
						tm:'',
						jldw:'',
						cd:'',
						cc:0,
						kk:0,
						gg:0,
						zl:0,
						ckjg:0,
						yjkc:0,
						bzqts:0,
						gzdj:0,
						shl:0,
						cplx:0,
						cpfl:'',
						cpbq:'',
						cppp:'',
						gys:'',
						ck:'',
						cptp:'',
						ys:'',
						cpgg:'',
						sku:'',
						cpxq:'',
						cjr:this.user.id,
						cjrs:this.user.name
					}
				}
				this.$router.push({
					name,
					params: { data }
				})
			},
			handleChange(lx,e,index) {
				if(lx == 'sl'){
					this.rkcps[index].hj = this.rkcps[index].dj * this.rkcps[index].sl
				}else if(lx == 'dj'){
					this.rkcps[index].hj = this.rkcps[index].dj * this.rkcps[index].sl
				}else{
					this.rkcps[index].dj = this.rkcps[index].hj / this.rkcps[index].sl
				}
				this.lists.spze = 0
				for(let i of this.rkcps){
					this.lists.spze += i.hj
				}
				this.lists.ddje = this.lists.spze * (this.lists.sl/100) + this.lists.spze
			},
			handleChanges(e){
				this.lists.ddje = this.lists.spze * (e/100) + this.lists.spze
			},
			//提交
			submit() {
				if(this.rkcps.length == 0){
					this.$message({
						type: "warning",
						message: "请选择入库产品"
					})
				}else{
					this.lists.cpsl = 0
					for(let i of this.rkcps){
						this.lists.cpsl += i.sl
					}
					this.lists.djsje = this.lists.spze
					let x = {
						data:this.lists,
						cpxx:this.rkcps
					}
					this.layout.showLoading()
					let url = !this.lists.id == true ? '/admin/cgrkd' : '/admin/cgrkd/' + this.lists.id
					this.axios.post(url, x, {
						token: true
					}).then(res => {
						this.$message({
							type: "success",
							message: !this.lists.id == true ? "下单成功" : "修改成功"
						})
						this.$router.push({
							name: "cggl_ddcl_cgrk"
						})
						this.layout.hideLoading()
					})
				}
			}
		},
	}
</script>

<style>
	.goods_create .el-form-item {
		margin-bottom: 15px;
	}
	.pt-a{
		padding-top: 20px;
	}

</style>
